export default {
  namespaced: true,

  state: {
    updatedSlots: false,
  },

  getters: {
    updatedSlots(state) {
      return state.updatedSlots;
    },
  },

  mutations: {
    SET_UPDATED_SLOTS(state, value) {
      state.updatedSlots = value;
    },
  },

  actions: {
    updatedSlots({ commit }, value) {
      commit('SET_UPDATED_SLOTS', value);
    },

  },
};
